module.exports = __webpack_public_path__ + "img/arrow-icon.e0cbc373.svg";